import gql from "graphql-tag";
import { gameFields, gameFieldsAaa } from "../fragments/game";

export const pageGQL = gql`
  ${gameFields}
  query Page($input: PageQueryInput) {
    page(input: $input) {
      total
      items {
        assets
        group
        id
        title
        position
        page
        metadata
        cards {
          assets
          group
          data {
            ... on LinkFeaturedCardData {
              __typename
              redirectUrl
            }
            ... on PathFeaturedCardData {
              __typename
              internalPath
            }
            ... on TournamentFeaturedCardData {
              __typename
              tournaments {
                game {
                  ...GameFields
                }
                id
                status
              }
            }
            ... on GameFeaturedCardData {
              __typename
              game {
                ...GameFields
              }
            }
          }
          linkType
          id
          metadata
          position
          title
        }
      }
    }
  }
`;

export const pageAaaGQL = gql`
  ${gameFieldsAaa}
  query Page($input: PageQueryInput) {
    page(input: $input) {
      total
      items {
        assets
        group
        id
        title
        position
        page
        metadata
        cards {
          assets
          group
          data {
            ... on LinkFeaturedCardData {
              __typename
              redirectUrl
            }
            ... on PathFeaturedCardData {
              __typename
              internalPath
            }
            ... on TournamentFeaturedCardData {
              __typename
              tournaments {
                game {
                  ...GameFieldsAaa
                }
                id
                status
              }
            }
            ... on GameFeaturedCardData {
              __typename
              game {
                ...GameFieldsAaa
              }
            }
          }
          linkType
          id
          metadata
          position
          title
        }
      }
    }
  }
`;
